import { Component, OnInit } from '@angular/core';
import { LanguageService } from '@app/services/language.service';

@Component({
    standalone: false,
    selector: 'app-translate',
    templateUrl: './translate.component.html',
    styleUrls: ['./translate.component.scss'],
})
export class TranslateComponent implements OnInit {
    currentLang: string = 'fr';

    languages = [
        {
            code: 'en',
            label: 'English',
            flag: 'https://flagcdn.com/20x15/us.png',
        },
        {
            code: 'fr',
            label: 'Français',
            flag: 'https://flagcdn.com/20x15/fr.png',
        },
    ];

    constructor(private languageService: LanguageService) {}

    ngOnInit(): void {
        this.currentLang = this.languageService.getCurrentLang() || 'fr';
    }

    switchLang(lang: string): void {
        this.languageService.use(lang);
        this.currentLang = lang;
    }
}
